type LoadingOverlayProps = {
  topOffset?: string;
  fullscreen?: boolean;
};

const LoadingOverlay = ({ topOffset = "0px", fullscreen = false }: LoadingOverlayProps) => {
  const overlayClass = fullscreen ? "fixed inset-0" : "absolute inset-x-0 bottom-0";

  return (
    <div
      className={`${overlayClass} bg-white/70 backdrop-blur-sm flex items-center justify-center z-20`}
      style={fullscreen ? undefined : { top: topOffset }}
    >
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary-600"></div>
    </div>
  );
};

export default LoadingOverlay;
